module.exports = __webpack_public_path__ + "static/media/logo_white.bc1aa183.svg";